import React from "react";
import NumericFormat from "react-number-format";

const Numbers = ({ courseCount, enrolmentCount }) => {
  const formatCompact = (value) => {
    const number = Number(value);

    if (number >= 1000) {
      return `${Math.floor(number / 1000)}k+`;
    }

    return value;
  };

  return (
    <section className="numbers" aria-label="42courses by the numbers">
      <div className="wrap">
        <div className="numbers-grid">
          <div>
            <div className="stat-num">
              80<small>%</small>
            </div>
            <div className="stat-label">Completion rate</div>
            <div className="stat-note">vs. industry ~10%</div>
          </div>
          <div>
            <div className="stat-num">
              <NumericFormat
                value={enrolmentCount}
                displayType="text"
                format={formatCompact}
              />
              <small>+</small>
            </div>
            <div className="stat-label">Learners</div>
            <div className="stat-note">and still counting</div>
          </div>
          <div>
            <div className="stat-num">
              {courseCount}
              <small>+</small>
            </div>
            <div className="stat-label">Courses</div>
            <div className="stat-note">all CPD-accredited</div>
          </div>
          <div>
            <div className="stat-num">42</div>
            <div className="stat-label">Is the answer</div>
            <div className="stat-note">the question is yours</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Numbers;
